import { store } from "../State/store/configureStore";

export const FEATURES = {
  ADD_PATIENT: "AddPatient",
  ADD_MEMBER: "AddMember",
  PATIENT_COMMUNICATION: "PatientCommunication",
  PUSH_NOTIFICATION_FOR_STATUS_UPDATE: "PushNotificationForStatusUpdate",
  PATIENT_INVITE_MANAGEMENT: "PatientInviteManagement",
  SMS_NOTIFICATION_FOR_ONBOARDING: "SMSNotificationForOnBoarding",
  EMAIL_NOTIFICATION_FOR_ON_BOARDING: "EmailNotificationForOnBoarding",
  TASKS: "Tasks",
  PUSH_NOTIFICATION_FOR_URGENT_TASKS: "PushNotificationForUrgentTasks",
  PUSH_NOTIFICATION_FOR_ALL_TASKS: "PushNotificationForAllTasks",
  HARD_DELETE_ARTIFACTS: "HardDeleteArtifacts",
  CUSTOM_PATIENT_LISTING_ACTIONS: "CustomPatientListingActions",
  FETCH_DETAILED_REPORT: "FetchDetailedReport",
  FETCH_THERAPY_COMPLIANCE_REPORT: "FetchTherapyComplianceReport",
  PACKAGE_IMPORT_EXPORT: "Package_Import_Export",
  REMINDER_SERVICE: "ReminderService",
  EDIT_DELETE_STATUS_MESSAGE: "AllowEditDeleteStatusMessage",
  SUBMIT_SURVEY_FROM_STAFF: "SubmitSurveyFromStaff",
  CUSTOM_PATIENT_REPORT: "CustomPatientReport",
  APPOINTMENT: "Appointment",
  VIDEO_CONFERENCE: "VideoConference",
  ENABLE_VIDEO_CALL_DIAGNOSTIC_LOGGING: "EnableVideoCallDiagnosticLogging",
  IMPORT_PATIENT_CSV: "ImportPatientCSV",
  CARE_TEAM_BASED_VISIBILITY: "CareTeamBasedVisibility",
  UNIQUE_ID_BASED_PATIENT_LOAD: "UniqueIDBasedPatientLoad",
  ADD_STAFF: "AddStaff",
  IMPORT_STAFF_CSV: "ImportStaffCSV",
  ENABLE_PATIENT_APP_IN_WEB: "EnablePatientAppInWeb",
  EXTERNAL_API_ACCESS: "ExternalAPIAccess",
  RULE_ENGINE: "RuleEngine",
  ALLOW_INTERACTIONS: "AllowInteractions",
  ALLOW_PRIVATE_MESSAGES: "AllowPrivateMessages",
  ALLOW_ADHOC_ADD_PATIENT_ON_APPOINTMENT: "AllowAdhocAddPatientOnAppointment",
  HIDE_STAFF_NOTES: "HideStaffNotes",
  HIDE_DASHBOARD: "HideDashboard",
  HIDE_PATIENT_DASHBOARD: "HidePatientDashboard",
  HIDE_STAFF_DASHBOARD: "HideStaffDashboard",
  HIDE_SURVEY_DASHBOARD: "HideSurveyDashboard",
  HIDE_TASKS_DASHBOARD: "HideTasksDashboard",
  SHOW_STAFF_INFO_PANEL: "ShowStaffInfoPanel",
  DISABLE_CHANGE_CP_NORMAL_STAFF: "DisableChangeCarePlanForNormalStaff",
  ENABLE_CLINIC_MANAGEMENT: "EnableClinicManagement",
  EXPORT_PATIENTS_AS_CSV: "ExportPatientsAsCSV",
  DISALLOW_FREE_TEXT_NOTES: "DisallowFreeTextNotes",
  APPOINTMENT_DISABLE_ADHOC_BOOKING: "AppointmentDisableAdhocBooking",
  ALLOW_UNAUTHENTICATED_VIDEO_CALLS: "AllowUnAuthenticatedVideoCalls",
  IMPORT_APPOINTMENT_SCHEDULE_CSV: "ImportAppointmentScheduleCSV",
  ENABLE_AIRVIEW_NOTES: "EnableAirViewNotes",
  MEDICATIONS: "Medications",
  ALLERGIES: "Allergies",
  ENABLE_TWOFA_TOTP: "EnableTwoFATOTP",
  ENABLE_TWOFA_AUTHENTICATOR: "EnableTwoFAAuthenticator",
  ENABLE_HCP_REPORTS: "EnableHcpReports",
  ENABLE_CONTENT_LOCALIZATION: "EnableContentLocalization",
  ENABLE_EMBEDDED_REPORTS: "EnableEmbeddedReports",
  REMOVE_CONTACTS_ON_DELETE: "RemoveContactsOnDelete",
  EMBEDDED_ACTIONS: "EmbeddedActions",
  ENABLE_CHARGE_ITEMS: "EnableChargeItems",
  ENABLE_CSV_EXPORT_SURVEY_RESPONSES: "EnableCSVExportOfSurveyResponses",
  BYPASS_ONBOARD_EMAIL_TEL_VALIDATION: "BypassOnboardEmailTelValidation",
  BREAKDOWN_ACTIVE_INACTIVE_TOTALS: "BreakdownActiveInactiveTotals",
  ENABLE_QUICK_ACTIONS_FOR_PATIENT: "EnableQuickActionsForPatient",
  MAKE_PATIENT_LOGINUSERID_PRIVATE: "MakePatientLoginUserIdPrivate",
  ENABLE_NEWGEN_CHARTS: "EnableNewGenCharts",
  SHOW_NEW_GEN_DASHBOARD: "ShowNewGenDashboard",
  DISABLE_COPY_TO_STAFF_NOTES_IN_TASKS: "DisableCopyToStaffNotesInTasks",
  DISALLOW_EDIT_STAFF_NOTES: "DisallowEditStaffNotes",
  USE_ONLY_MONTH_YEAR_FOR_DOB: "UseOnlyMonthYearForDOB",
  BLOCK_PATIENT_PHOTO_UPLOAD: "BlockPatientPhotoUpload",
  ENABLE_AI: "EnableAIIntegration",
  ENABLE_SMART_DOCUMENTS: "EnableSmartDocuments",
  ENABLE_SMART_NOTES: "EnableSmartNotes",
  SHOW_EPISODES_OF_CARE: "ShowEpisodesOfCare",
  ALLOW_PATIENT_CARE_PLAN_EDIT: "AllowEditCarePlan",
  ENABLE_ADHERANCE_REPORT: "EnableAdheranceChart",
  ALLOW_CHAT_WITH_PATIENT_IN_STATUS_MESSAGE:
    "StaffPatientChat",
  SHOW_EPISODES_OF_CARE: "ShowEpisodesOfCare",
  ENABLE_CONFIGURABLE_CLINIC_COLUMNS: "EnableConfigurableClinicColumns",
  SHOW_PATIENT_GRID_VIEW: "ShowPatientsGridView",
  ENABLE_MEDICATIONS_IN_PATIENT_APP: "MedicationsInPatientMobileApp",
  ENABLE_ALLERGIES_IN_PATIENT_APP: "AllergiesInPatientMobileApp",
  ENABLE_GOAL_FEATURE: "GoalFetaure",
  ENABLE_INTERVENTIONS_IN_TOP_LEVEL_GOALS: "EnableInterventionsInTopLevelGoals",
  ENABLE_GOAL_TARGET: "EnableGoalTarget",
  ENABLE_ARTIFACT_AUDIT: "EnableArtifactAudit",
  ENABLE_STAFF_AUDIT: "EnableStaffAudit",
  ENABLE_DEVICE_INTEGRATION: "EnableDeviceIntegration",
  ADD_DOCUMENTS_BY_PATIENT: "AddDocumentsByPatient",
  ENABLE_NEXT_GEN_WEB_APP: "EnableNextGenWebApp",
  AUTO_TRANSLATE_USER_INPUT: "AutoTranslateUserInput",
  ENABLE_STAFF_QUICK_ACTIONS: "EnableStaffQuickActions",
  ENABLE_SMART_CANCER_SCHEDULING: "EnableSmartCancerScheduling",
  ENABLE_AGENTS: "EnableAgents",
  ENABLE_STAFF_NOTES_SUMMARY: "EnableStaffNotesSummary",
  ENABLE_PATIENT_SUMMARY: "EnablePatientSummary",
  ENABLE_PWA_INSTALL: "EnablePWAInstall",
  ENABLE_PATIENT_AGENT: "EnablePatientAgent",
  SHOW_BILLING_REPORT: "ShowBillingReport",
  ENABLE_DIET_TRACKING: "EnableDietTracking",
  HSE_TERMINOLOGY_ENABLED: "EnableHSETerminology",
  ENABLE_ATTRIBUTE_WHERE_USED: "EnableAttributeWhereUsed",
  ENABLE_FHIR_INTEGRATION: "EnableFhirIntegration",
  SHOW_PATIENTS_THEIR_SUPPORT_REQUESTS: "ShowPatientsTheirSupportRequests",
  HIDE_TASKS_IN_PATIENT_WEB_APP: "HideTasksInPatientWebApp",
  ENABLE_CALL_SUMMARIES: "EnableCallSummaries",
  HIDE_PROGRESS_IN_PATIENT_WEB_APP: "HideProgressInPatientWebApp",
  HIDE_DOCUMENTS_IN_PATIENT_WEB_APP: "HideDocumentsInPatientWebApp",
  ENABLE_NIGHTLY_TRAFFIC_LIGHT_CALCULATION:
    "EnableNightlyTrafficLightCalculation",
  ALLOW_PUBLIC_URL_CHANNEL_CREATION: "AllowPublicURLChannelCreation",
  ENABLE_VOICE_NOTE_DICTATION: "EnableVoiceNoteDictation",
  RECOMMEND_PUBLISHED_SCHEDULES_IN_BOOKING: "RecommendPublishedSchedulesInBooking",
  // MYP-8760: 'Add known holidays' lookup in facility config
  FACILITY_HOLIDAY_LOOKUP: "FacilityHolidayLookup",
};

class FeaturesService {
  static canAddPatient() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ADD_PATIENT) !== -1;
  }

  static canImportPatientCSV() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.IMPORT_PATIENT_CSV) !== -1;
  }

  static canTasks() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.TASKS) !== -1;
  }

  static canReminder() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.REMINDER_SERVICE) !== -1;
  }

  static canDoAppointments() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.APPOINTMENT) !== -1;
  }

  static canStaffSubmitSurvey() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.SUBMIT_SURVEY_FROM_STAFF) !== -1
    );
  }

  static canHaveCareTeamBasedVisibility() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.CARE_TEAM_BASED_VISIBILITY) !== -1
    );
  }

  static isUniqueIdBasedPatientLoad() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.UNIQUE_ID_BASED_PATIENT_LOAD) !== -1
    );
  }

  static shouldHideStaffNotes() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.HIDE_STAFF_NOTES) !== -1;
  }

  static shouldHideDashboard() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.HIDE_DASHBOARD) !== -1;
  }

  static shouldHidePatientsDashboard() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.HIDE_PATIENT_DASHBOARD) !== -1;
  }

  static shouldHideStaffDashboard() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.HIDE_STAFF_DASHBOARD) !== -1;
  }

  static shouldHideSurveyDashboard() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.HIDE_SURVEY_DASHBOARD) !== -1;
  }

  static shouldHideTasksDashboard() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.HIDE_TASKS_DASHBOARD) !== -1;
  }

  static canShowStaffInfoPanel() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.SHOW_STAFF_INFO_PANEL) !== -1;
  }

  static membersAllowed() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ADD_MEMBER) !== -1;
  }

  static disableChangeCPForNormalStaff() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.DISABLE_CHANGE_CP_NORMAL_STAFF) !== -1
    );
  }

  static canHaveClinics() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_CLINIC_MANAGEMENT) !== -1
    );
  }

  static showAllowNotesForTasks() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.DISALLOW_FREE_TEXT_NOTES) === -1
    );
  }

  static allowAdhocBooking() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.APPOINTMENT_DISABLE_ADHOC_BOOKING) === -1
    );
  }

  static canGenerateCallSummaries() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_CALL_SUMMARIES) !== -1
    );
  }

  static allowUnAuthVideoCalls() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ALLOW_UNAUTHENTICATED_VIDEO_CALLS) !== -1
    );
  }

  static allowImportAppointmentScheduleCSV() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.IMPORT_APPOINTMENT_SCHEDULE_CSV) !== -1
    );
  }

  static allowAirViewNotes() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_AIRVIEW_NOTES) !== -1;
  }

  static canDoMedications() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.MEDICATIONS) !== -1;
  }

  static canDoAllergies() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ALLERGIES) !== -1;
  }

  static isLocalizationEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      (features.indexOf(FEATURES.ENABLE_CONTENT_LOCALIZATION) !== -1 ||
        features.indexOf(FEATURES.ENABLE_CONTENT_LOCALIZATION) !== -1)
    );
  }

  static isConsolidatedReportEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      (features.indexOf(FEATURES.CUSTOM_PATIENT_REPORT) !== -1 ||
        features.indexOf(FEATURES.CUSTOM_PATIENT_REPORT) !== -1)
    );
  }

  static isMFAEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      (features.indexOf(FEATURES.ENABLE_TWOFA_TOTP) !== -1 ||
        features.indexOf(FEATURES.ENABLE_TWOFA_AUTHENTICATOR) !== -1)
    );
  }

  static hideAppointments() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.APPOINTMENT) === -1;
  }

  static isPatientAppEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_PATIENT_APP_IN_WEB) !== -1
    );
  }

  static isHCPReportEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_HCP_REPORTS) !== -1;
  }

  static doRemoveContactsOnDelete() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.REMOVE_CONTACTS_ON_DELETE) !== -1
    );
  }

  static canUseEmbeddedActions() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.EMBEDDED_ACTIONS) !== -1;
  }

  static enableChargeItems() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_CHARGE_ITEMS) !== -1;
  }

  static canShowPatientStatsBreakdown() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.BREAKDOWN_ACTIVE_INACTIVE_TOTALS) !== -1
    );
  }

  static areEmbeddedReportsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_EMBEDDED_REPORTS) !== -1
    );
  }

  static enablePatientQuickActions() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_QUICK_ACTIONS_FOR_PATIENT) !== -1
    );
  }

  static hidePatientLoginUserId() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.MAKE_PATIENT_LOGINUSERID_PRIVATE) !== -1
    );
  }

  static useNewCharting() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_NEWGEN_CHARTS) !== -1;
  }

  static isGeronteUser() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.SHOW_NEW_GEN_DASHBOARD) !== -1;
  }

  static useOnlyMonthYearForDOB() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.USE_ONLY_MONTH_YEAR_FOR_DOB) !== -1
    );
  }

  static canCopyToStaffNotesInTasks() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.DISABLE_COPY_TO_STAFF_NOTES_IN_TASKS) === -1
    );
  }

  static canEditStaffNotes() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.DISALLOW_EDIT_STAFF_NOTES) === -1
    );
  }

  static blockPatientPhotoUpload() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.BLOCK_PATIENT_PHOTO_UPLOAD) === -1
    );
  }

  static isAiEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_AI) !== -1;
  }

  static isPatientSummaryEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_PATIENT_SUMMARY) !== -1;
  }

  static isStaffNotesSummaryEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_STAFF_NOTES_SUMMARY) !== -1
    );
  }

  static isAgentsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_AGENTS) !== -1;
  }

  static isSmartDocumentsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_SMART_DOCUMENTS) !== -1;
  }

  static isSmartNotesEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_SMART_NOTES) !== -1;
  }

  static showAdheranceReport() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_ADHERANCE_REPORT) !== -1
    );
  }
  static showChatInStatusMessage() {
    let features = store.getState().user.provisionedFeatures;
    if (!features) return false;
    // Accept either the new StaffPatientChat enum (canonical) or the legacy
    // AllowChatWithPatientInStatusMessage one. Facilities migrate at their own
    // pace; the UI must work for both.
    return (
      features.indexOf("StaffPatientChat") !== -1 ||
      features.indexOf("AllowChatWithPatientInStatusMessage") !== -1
    );
  }

  static showEpisodesOfCare() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.SHOW_EPISODES_OF_CARE) !== -1;
  }

  /** Booking wizard leads with published schedules (clinic + template pairs). ESD-731 / ESD-736. */
  static recommendPublishedSchedulesInBooking() {
    let features = store.getState().user.provisionedFeatures;
    return (
      !!features &&
      features.indexOf(FEATURES.RECOMMEND_PUBLISHED_SCHEDULES_IN_BOOKING) !== -1
    );
  }

  static showClinicColumns() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_CONFIGURABLE_CLINIC_COLUMNS) !== -1
    );
  }

  static canShowPatientGridView() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.SHOW_PATIENT_GRID_VIEW) !== -1;
  }

  static enableCSVExportSurveyResponses() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_CSV_EXPORT_SURVEY_RESPONSES) !== -1
    );
  }

  static patientCanAddMedications() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_MEDICATIONS_IN_PATIENT_APP) !== -1
    );
  }

  static goalsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_GOAL_FEATURE) !== -1;
  }
  static interventionsInTopLevelGoalsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_INTERVENTIONS_IN_TOP_LEVEL_GOALS) !== -1
    );
  }
  static enableCSVExportSurveyResponses() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_CSV_EXPORT_SURVEY_RESPONSES) !== -1
    );
  }
  static goalsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_GOAL_FEATURE) !== -1;
  }
  static interventionsInTopLevelGoalsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_INTERVENTIONS_IN_TOP_LEVEL_GOALS) !== -1
    );
  }
  static goalsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_GOAL_FEATURE) !== -1;
  }
  static interventionsInTopLevelGoalsEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_INTERVENTIONS_IN_TOP_LEVEL_GOALS) !== -1
    );
  }
  static enableGoalTarget() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_GOAL_TARGET) !== -1;
  }
  static enableArtifactAudit() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_ARTIFACT_AUDIT) !== -1;
  }
  static enableStaffAudit() {
    let features = store.getState().user.provisionedFeatures;
    return features && features.indexOf(FEATURES.ENABLE_STAFF_AUDIT) !== -1;
  }
  static enableDeviceIntegration() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_DEVICE_INTEGRATION) !== -1
    );
  }
  static enablePatientUploadDcouments() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ADD_DOCUMENTS_BY_PATIENT) !== -1
    );
  }
  static enableNewPatientApp() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_NEXT_GEN_WEB_APP) !== -1
    );
  }

  static autoTranslateUserInput() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.AUTO_TRANSLATE_USER_INPUT) !== -1
    );
  }
  static enableSmartCancerScheduling() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_SMART_CANCER_SCHEDULING) !== -1
    );
  }

  static enablePWAInstall() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_PWA_INSTALL) !== -1
    );
  }

  static isPatientAgentEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_PATIENT_AGENT) !== -1
    );
  }

  static isDietTrackingEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_DIET_TRACKING) !== -1
    );
  }

  static isTerminologyEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.HSE_TERMINOLOGY_ENABLED) !== -1
    );
  }

  static isAttributeWhereUsedEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_ATTRIBUTE_WHERE_USED) !== -1
    );
  }


  static isVoiceNoteDictationEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_VOICE_NOTE_DICTATION) !== -1
    );
  }

  static isFhirIntegrationEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features && features.indexOf(FEATURES.ENABLE_FHIR_INTEGRATION) !== -1
    );
  }

  static showPatientsTheirSupportRequests() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.SHOW_PATIENTS_THEIR_SUPPORT_REQUESTS) !== -1
    );
  }

  static shouldHideTasksInPatientWebApp() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.HIDE_TASKS_IN_PATIENT_WEB_APP) !== -1
    );
  }

  static shouldHideProgressInPatientWebApp() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.HIDE_PROGRESS_IN_PATIENT_WEB_APP) !== -1
    );
  }

  static shouldHideDocumentsInPatientWebApp() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.HIDE_DOCUMENTS_IN_PATIENT_WEB_APP) !== -1
    );
  }
  /**
   * Whether client-side WebRTC diagnostics should be collected for this call.
   *
   * Deliberately fails OPEN, because this runs on the patient side too, where
   * the join link is anonymous and `provisionedFeatures` is never populated.
   * Returning false there would silently lose exactly half of every call's
   * diagnostics.
   *
   * So: skip only when we can positively see the facility has NOT enabled it.
   * When features are unknown, post and let the backend decide — it resolves
   * the facility from the room and is the authoritative gate. Nothing is
   * stored unless FeatureSet.EnableVideoCallDiagnosticLogging is on.
   */
  static isVideoCallDiagnosticLoggingEnabled() {
    const features = store.getState().user.provisionedFeatures;
    if (!features || !features.length) return true; // unknown -> backend decides
    return (
      features.indexOf(FEATURES.ENABLE_VIDEO_CALL_DIAGNOSTIC_LOGGING) !== -1
    );
  }

  static isNightlyTrafficLightCalculationEnabled() {
    let features = store.getState().user.provisionedFeatures;
    return (
      features &&
      features.indexOf(FEATURES.ENABLE_NIGHTLY_TRAFFIC_LIGHT_CALCULATION) !== -1
    );
  }

  // Gates the "Public URL Channel" option in Create Channel (staff /channels).
  // Fails closed: an unknown feature list hides the option.
  static canCreatePublicURLChannel() {
    let features = store.getState().user.provisionedFeatures;
    return !!(
      features &&
      features.indexOf(FEATURES.ALLOW_PUBLIC_URL_CHANNEL_CREATION) !== -1
    );
  }
}



export default FeaturesService;
